/**
 * Created by BFR on 04/05/2017.
 */
define('lisAnaDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'lisAnaDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var LisAnaDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showLisAnaInfo(data);
    },

    showLisAnaInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('lisAnaDetailTab').show(view);
    }
  };

  module.exports = LisAnaDetailTabController;
});
